import { render } from "./Button.vue?vue&type=template&id=015de462"
import script from "./Button.vue?vue&type=script&setup=true&lang=js"
export * from "./Button.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "015de462"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('015de462', __exports__)) {
    console.log('reload')
    api.reload('015de462', __exports__)
  }
  
  module.hot.accept("./Button.vue?vue&type=template&id=015de462", () => {
    console.log('re-render')
    api.rerender('015de462', render)
  })

}


export default __exports__